export default __webpack_public_path__ + "static/media/ilustraciones_por_Fibro_What.51824592.jpg";